export default __webpack_public_path__ + "static/media/IX_Old_White.786c808b.png";